import metric2 from '../background-images/rep/MetricItem1.svg';
import metric3 from '../background-images/rep/MetricItem2.svg';
import metric1 from '../background-images/rep/MetricItem.svg';

export const ApplicationStartShowcaseRep = () => (
  <div className='flex h-full w-full flex-col justify-between bg-gray-50 px-12 pb-[33px] pt-[76px]'>
    <h1 className='max-w-[650px] font-sans text-display-3xl font-bold text-gray-600'>
      Join a <span className='text-accent-600'>global</span> network of purpose-driven organizations
    </h1>
    <div className='flex items-center gap-5 pb-10'>
      <img src={metric1} alt='' className='h-auto w-0 flex-1' />
      <img src={metric2} alt='' className='h-auto w-0 flex-1' />
      <img src={metric3} alt='' className='h-auto w-0 flex-1' />
    </div>
  </div>
);
